import { render, staticRenderFns } from "./EditIngredientNew.vue?vue&type=template&id=9c25d186&scoped=true&"
import script from "./EditIngredientNew.vue?vue&type=script&lang=js&"
export * from "./EditIngredientNew.vue?vue&type=script&lang=js&"
import style0 from "./EditIngredientNew.vue?vue&type=style&index=0&id=9c25d186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c25d186",
  null
  
)

export default component.exports